<form #fPassword="ngForm" (ngSubmit)="onOk()">
  <div class="title" fxLayout="row" fxLayoutAlign="start">
    <span mat-dialog-title role="heading" aria-level="1">Reset Password</span>
  </div>
  <mat-dialog-content fxLayoutAlign="center" fxLayout="column">
    <mat-form-field floatLabel="always" appearance="outline">
      <mat-label>Email</mat-label>
      <input matInput name="email" [(ngModel)]="data.email" type="email" required>
    </mat-form-field>
  </mat-dialog-content>
  <mat-dialog-actions fxLayout="row" fxLayoutAlign="end">
    <button mat-raised-button type="button" color="warn" (click)="onCancel()">Cancel</button>
    <button mat-raised-button type="submit" color="primary" [disabled]="fPassword.invalid || !fPassword.dirty || isLoading">Ok</button>
  </mat-dialog-actions>
</form>
